import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { AppNavigationService } from "app/layout/service/app.navigation.service";
import { AuthService } from "app/shared/auth.service";

@Component({
  selector: "app-handheld-layout",
  templateUrl: "./handheld-layout.component.html",
  styleUrls: ["./handheld-layout.component.scss"],
  standalone: false,
})
export class HandheldLayoutComponent implements OnInit, OnDestroy {
  userInitials = "";

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private navigationService: AppNavigationService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.navigationService.hide();
    this.document.body.classList.add("handheld-mode");
    const user = this.authService.getUser();
    this.userInitials = user?.initials || "?";
  }

  ngOnDestroy() {
    this.document.body.classList.remove("handheld-mode");
    this.navigationService.show();
  }

  logout() {
    this.authService.logout();
  }
}
